import React from 'react'
import { Link } from 'react-router-dom'

import { cn } from 'utils/utils'

import { StoredReviewItem } from '../../../../schemas/playbook'
import { dedupeReferencePages } from '../../utils/playbook-utils'

interface RuleItemProps {
  item: StoredReviewItem
  index: number
  isLastInSection: boolean
}

export const RuleItem: React.FC<RuleItemProps> = ({
  item,
  index,
  isLastInSection,
}) => {
  const pageNoText = dedupeReferencePages(item.references)
  return (
    <Link to={`/playbook-rule/${index}`} viewTransition>
      <div
        className={cn('rounded-md p-2 transition hover:bg-secondary-hover', {
          'rounded-b-md': isLastInSection,
        })}
      >
        <div className="text-xs font-semibold text-primary">
          {item.ruleName}
        </div>
        <div className="flex justify-between gap-2">
          <span className="line-clamp-2 text-xs text-secondary">
            {item.explanation}
          </span>
          {/* Basis is set to 6ch to account for the longest page number text. */}
          <span className="shrink-0 basis-[6ch] self-end text-right text-xs text-secondary">
            {pageNoText}
          </span>
        </div>
      </div>
    </Link>
  )
}
